import store from '@/store'
import axios from 'axios'

// ---------------------
//  注意，此js中用到了Vue 实例，所以，在调用前需通过initWecomSdk时传入Vue实例，如：
//   ```
//   mounted() {
//     wwJsApi.initWecomSdk(this)
//   },
//  ```
// ---------------------

let initialized = false
let user = {} // 从 localStorage 中获取的用户信息
let $fetch = null
let $vue = null
// WECOM-JSSDK的所有接口(不完全)
const wxworkJsApies = [
  'checkJsApi',
  'getContext',
  'getExternalContact',

  // 客户联系 https://developer.work.weixin.qq.com/document/path/98672 开始
  'selectEnterpriseContact', // 选择通讯录成员
  'openUserProfile', // 调起个人信息页面
  'getCurExternalContact', // 获取当前外部联系人 userId
  'getCurExternalChat', //
  'selectCorpGroupContact', // 上下游选人接口
  'shareToExternalContact', // 群发消息给客户
  'shareToExternalChat', // 分享消息到客户群聊 https://developer.work.weixin.qq.com/document/path/98678
  'navigateToAddCustomer', // 调起添加客户界面
  'shareToExternalMoments', // 分享消息到客户朋友圈 https://developer.work.weixin.qq.com/document/path/98680
  'updateMomentsSetting', // 更新客户朋友圈(封面与签名) https://developer.work.weixin.qq.com/document/path/98681

  // 微信客服类 https://developer.work.weixin.qq.com/document/path/98683
  'sendChatMessage', // 向当前会话发送消息
  'navigateToKfChat', // 调起微信客服消息界面

  // 对外收款 https://developer.work.weixin.qq.com/document/path/98686
  'createExternalPayment', // 创建上下游付款单
  'refundExternalPayment', // 发起退款

  // 上下游
  'getCurCorpGroupContact', // 获取上下游联系人ID
  'getCurCorpGroupChat', // 获取上下游互联群ID

  // 会话
  'openEnterpriseChat', // 打开会话
  'updateEnterpriseChat', // 变更群成成员
  'openExistedChatWithMsg', // 打开已有群聊并发送消息
  'hideChatAttachmentMenu', // 隐藏会话附件菜单

  'setShareAttr', // 设置私密消息
  'getShareInfo', // 获取私密消息信息
  'createCorpGroupChat', // 创建企业互联/上下游会话
  'updateCorpGroupChat', // 变更企业互联/上下游成员

  // 分享
  'onMenuShareAppMessage', // 监听「转发」按钮点击
  'onMenuShareWechat', // 监听「微信」按钮点击
  'onMenuShareTimeline', // 监听「朋友圈」按钮点击
  'shareAppMessage', // 自定义转发到会话
  'shareWechatMessage', // 自定义转发到微信

  // 图像
  'chooseImage', // 拍照或从手机相册中选图
  'previewImage', // 预览图片
  'uploadImage', // 上传图片
  'downloadImage', // 下载图片
  'getLocalImgData', // 获取本地图片内容

  // 音频
  'startRecord', // 开始录音
  'stopRecord', // 停止录音
  'onVoiceRecordEnd', // 监听录音自动停止
  'playVoice', // 播放语音
  'pauseVoice', // 暂停播放
  'stopVoice', // 停止播放
  'onVoicePlayEnd', // 监听语音播放完毕
  'previewVoice', // 预览音频
  'uploadVoice', // 上传音频
  'downloadVoice', // 下载音频
  'translateVoice', // 语音转文字
  // 文件
  'previewFile', // 预览文件
  // 地理位置 https://developer.work.weixin.qq.com/document/path/98666
  'openLocation', // 打开内置地图
  'getLocation', // 获取位置
  'startAutoLBS', // 开启自动持续定位
  'stopAutoLBS', // 停止自动持续定位
  'onLocationChange', // 监听位置变化

  // 蓝牙  https://developer.work.weixin.qq.com/document/path/98634
  // 'openBluetoothAdapter', // 初始化蓝牙模块
  // 'closeBluetoothAdapter', // 关闭蓝牙模块
  // 'getBluetoothAdapterState', // 获取蓝牙模块状态
  // 'startBluetoothDevicesDiscovery', // 开始搜索附近的蓝牙设备
  // 'stopBluetoothDevicesDiscovery', // 停止搜索附近的蓝牙设备
  // 'getBluetoothDevices', // 获取搜索发现到的蓝牙设备
  // 'getConnectedBluetoothDevices', // 获取已连接的设备
  // 'onBluetoothAdapterStateChange', // 监听蓝牙状态变化

  // 蓝牙(BLE) https://developer.work.weixin.qq.com/document/path/98644
  // 'createBLEConnection', // 连接低功耗蓝牙设备
  // 'closeBLEConnection', // 断开与低功耗蓝牙设备的连接
  // 'onBLEConnectionStateChange', // 监听蓝牙连接状态变化
  // 'getBLEDeviceServices', // 获取蓝牙设备所有服务(service)
  // ......

  // 界面
  'onHistoryBack', // 监听页面返回
  'hideOptionMenu', // 隐藏右上角菜单
  'showOptionMenu', // 显示右上角菜单
  'closeWindow', // 关闭当前窗口
  // ......

  // 系统界面
  'scanQRCode', // 调用微信扫一扫接口
  'chooseInvoice', // 调用微信选择发票接口
  'enterpriseVerify', // 跳转认证界面
  'openAppManage', // 调起应用管理界面

  // 审批 https://developer.work.weixin.qq.com/document/path/98699
  'thirdPartyOpenPage' // 第三方发起审批页面
]

// 初始化WECOM-JSSDK，注意，不在企业微信客户端不会执行。主要包括：
//   1# 注册当前页面的企业身份
//   2# 注册当前页面的应用身份
//   3# 获取应用入口: single_chat_tools - 从单聊会话的工具栏进入，group_chat_tools - 从群聊会话的工具栏进入, contact_profile - 从联系人详情进入, ...
async function initWecomSdk(vueInstance) {
  if (initialized) {
    // console.log('WecomJsSdk 已经初始化完毕')
    return
  }

  user = localStorage.getObject('user')
  const accessToken = localStorage.getItem('access_token')
  if (user.access_token && !accessToken) {
    localStorage.setItem('access_token', accessToken)
  }

  $fetch = vueInstance.$fetch
  $vue = vueInstance
  // 检查当前客户端版本是否支持指定的JS接口。可以不检测
  // ww.checkJsApi({
  //   jsApiList: wxworkJsApies,
  //   complete: (res) => {
  //     console.log('checkJsApi complete', res, wxworkJsApies)
  //   }
  // })

  console.log('初始化 WecomJsSdk ...')
  // 初始化WECOM-JSSDK: 1#、注册当前页面的企业身份信
  const option = {
    corpId: user.ww_corpid, // 当前用户所属企业id
    jsApiList: ['getContext', 'getExternalContact', 'sendChatMessage', 'getLocation'], // 需要使用的JS接口列表, 可以不传但传了不能为空
    getConfigSignature: (url) => getConfigSignature(url) // 修改为箭头函数
  }
  try {
    const callback = {
      onConfigSuccess: (resp) => {
        console.log('注册企业身份成功 ', resp)
        this.wecomJssdkInit = true
        // 初始化WECOM-JSSDK: 2#、注册当前页面的应用身份:
        registerAgent()
      },
      onConfigFail: (resp) => {
        console.log('注册企业身份失败: ', resp, option)
        const errMsg = resp.errMsg.substring(0, resp.errMsg.indexOf('more info'))
        $vue.$toast(`注册企业身份失败 (${errMsg})`)
      }
    }
    ww.register({...option, ...callback})
  } catch (error) {
    console.error('初始化 WecomJsSdk 失败:', error)
  }
}

// 注册当前页面的应用身份: 当企业身份注册成功之后执行，在注册企业身份的基础上额外增加两个参数agentId和getAgentConfigSignature
async function registerAgent() {
  const option = {
    corpId: user.ww_corpid, // 当前用户所属企业id
    agentId: user.ww_agentid, // 当前第三方应用 AgentID,如1000012. 注意同一个第三方应用在不同企业内安装后AgentID是不同的，但在此企业内是唯一的
    jsApiList: wxworkJsApies, // 需要使用的JS接口列表
    getConfigSignature: (url) => getConfigSignature(url),
    getAgentConfigSignature: (url) => getAgentConfigSignature(url)
  }
  const callback = {
    onAgentConfigSuccess: (resp) => {
      console.log('注册应用成功: ', resp)
      // 注册应用成功后，需要判断进入应用的入口，根据入口做进一步处理
      initialized = true
      handleAppEntry()
    },
    onAgentConfigFail: (resp) => {
      console.error('注册应用失败: ', resp)
      if (resp.errMsg) {
        $vue.$toast(`注册应用失败，(Err:${resp.errMsg})`)
      }
    }
  }
  console.log('注册应用: 参数', option)
  ww.register({...option, ...callback})
}
// 获取企业微信JSAPI配置签名
async function getConfigSignature(url) {
  console.log('getConfigSignature called with url:', url) // 添加日志

  return axios.post(`/api/wxwork/get-corp-config-signature?access-token=${user.access_token}`, {
    url: url,
    corp_id: user.ww_corpid
  }).then(
    ({data}) => {
      const result = data.data
      // console.log('getConfigSignature result:', result) // 添加日志
      return {
        timestamp: result.timestamp,
        nonceStr: result.nonceStr,
        signature: result.signature
      }
    }
  ).catch(error => {
    console.error('获取企业微信JSAPI配置签名失败:', error) // 添加错误处理
    // throw error
  })
}
// 获取企业微信应用JSAPI签名
async function getAgentConfigSignature(url) {
  return axios.post(`/api/wxwork/get-agent-config-signature?access-token=${user.access_token}`, {
    url: url,
    corp_id: user.ww_corpid, // 授权安装的企业corpId
    agent_id: user.ww_agentid // 授权安装的企业安装后自己的应用ID，每个企业安装后各有各自的id会重复，但在本企业内时唯一的
  }).then(
    ({data}) => {
      const result = data.data
      return {
        timestamp: result.timestamp,
        nonceStr: result.nonceStr,
        signature: result.signature
      }
    }
  ).catch(error => {
    console.error('获取企业微信应用JSAPI签名失败:', error)
  })
}

// async function getSuiteConfigSignature() {
//   本应用中不应该使用到此"应用登录鉴权",因此未实现到。参见 https://developer.work.weixin.qq.com/document/path/98416#应用登录鉴权'
//   console.error('应用登录鉴权(getSuiteConfigSignature)未实现, 参见 https://developer.work.weixin.qq.com/document/path/98416#应用登录鉴权')
//   return Promise.reject(new Error('应用登录鉴权(getSuiteConfigSignature)未实现'))
// }

async function getContext() {
  // 在调用 ww.register 后，页面可以立刻调用其他 JSAPI，JS-SDK 内部会自行处理注册身份信息的时序
  // 参见 https://developer.work.weixin.qq.com/document/path/98416#接口约定
  return new Promise((resolve, reject) => {
    ww.getContext({
      success: (resp) => {
        // 成功回调，result.errMsg 固定格式为“方法名:ok”,即'getContext:ok'
        localStorage.setItem('ww_context', resp.entry)
        resolve(resp.entry)
        if (resp.entry === 'single_chat_tools') {
          console.log('获取到打开此应用的入口: single_chat_tools')

          // 测试: 向当前聊天窗口发送一条消息(放到聊天消息发送输入框但并不真正发送，需要用户手工点击发送)
          //   ww.sendChatMessage({
          //     msgtype: 'text',
          //     enterChat: true, // 发送完成后进入会话
          //     text: {
          //       content: '你好，请问有什么可以帮到您~'
          //     }
          //   })
        } else if (resp.entry === 'contact_profile') {
          console.log('ww.getContext result.entry: contact_profile')
        }
      },
      complete: (resp) => {
        if (resp.errCode !== 0) {
          console.log('ww.getContext FAIL', resp)
        }
      }
    })
  })
}

/**
 * 获取当前外部联系人的 userId
 * @returns {Promise<string>} 返回一个 Promise，解析为当前外部联系人的 userId
 */
async function getCurExternalContact() {
  // https://developer.work.weixin.qq.com/document/path/98674#获取当前外部联系人 userId
  return new Promise((resolve, reject) => {
    ww.getCurExternalContact({
      success: (resp) => {
        const userId = resp.userId
        console.log('ww.getCurExternalContact result.userId: ' + userId)
        resolve(userId) // 将 Promise 状态变为成功，并返回 userId, 调用者可使用 .then(userId => {...}) 进行处理
      },
      fail: (err) => {
        console.error('ww.getCurExternalContact failed: ', err)
        reject(err) // 将 Promise 状态变为失败，调用者可使用 .catch(err => {...}) 进行处理
      }
    })
  })
}
// 处理企业微信应用入口，根据入口情况不同做些不同的处理
// 会将获取到的外部联系人信息、所属公司、聊天id等存在 store 中
async function handleAppEntry() {
  const data = await ww.getContext()
  let entry = ''
  if (data.errCode) {
    console.error('getContext failed: ', data)
    return entry
  }

  console.log('getContext : ', data.entry)
  entry = data.entry
  // const appEntry = store.getters.getWwAppEntry; // 从状态管理中获取企业微信入口
  let resp = null
  let userId = ''
  let groupChatId = ''
  let corpId = ''
  try {
    switch (entry) {
      case 'single_chat_tools': // 从单聊会话的工具栏进入
      case 'contact_profile': // 从联系人详情进入
        // 客户端API 接口文档 https://developer.work.weixin.qq.com/document/path/98674
        resp = await ww.getCurExternalContact()
        if (resp.errCode === 0) {
          userId = resp.userId
          store.dispatch('getExtContact', userId) // 通过 store 异步获取当前外部联系人的详细信息
          store.dispatch('getCppContact', userId) // 通过 store 异步获取当前外部联系人在业务系统中的详细信息
        } else {
          console.error('getCurExternalContact failed: ', resp)
        }
        break
      case 'group_chat_tools': // 从群聊会话的工具栏进入
        resp = await ww.getCurExternalChat()
        if (resp.errCode === 0) {
          groupChatId = resp.chatId
          console.log(`从群聊会话的工具栏进入, 群聊id: ${groupChatId}`)
        }
        break
      case 'chat_attachment': // 从会话的聊天附件栏进入
        // 测试，向当前会话发送消息
        ww.sendChatMessage({
          msgtype: 'text',
          text: {
            content: '大家好，我是云玺印企微助手...'
          }
        })
        break
      case 'single_kf_tools': // 从微信客服的工具栏进入
      case 'chain_single_chat_tools': // 上下游单聊会话的工具栏
        // 获取当前上下游联系人用户ID及其企业id
        resp = await ww.getCurCorpGroupContact()
        if (resp.errCode === 0) {
          corpId = resp.corpId
          userId = resp.userId
          console.log(`从群聊会话的工具栏进入, 当前联系人的企业ID ${corpId}, 当前联系人用户ID ${userId}`)
        }
        break
      case 'chain_group_chat_tools': // 上下游群聊会话的工具栏
        // 上下游群聊的会话id
        resp = await ww.getCurCorpGroupChat()
        if (resp.errCode === 0) {
          groupChatId = resp.chatId
          console.log(`获取当前上下游互联群的群ID: ${groupChatId}`)
        }

        break
      case 'normal': // 除以上场景之外进入，例如工作台，聊天会话等
        console.log(`应用入口: normal`)
        break
      default:
        break
    }
  } catch (error) {
    console.error('处理应用入口场景时有错, 请注意授权', error)
    if (process.env.WXWORK_APPTYPE === 'proxy') {
      window.app.$vux('请管理员在企业微信管理后台检查授权：应用管理->自建:进入”云玺CRM“->授权信息:点查看进入->编辑权限')
    } else {
      window.app.$vux('可能需要安装应用，安装应用时对许需要的授权要全部勾选上')
    }
  }

  store.commit('wwAppEntry', entry) // 在状态管理中存入企业微信入口值
  store.commit('wwGroupChatId', groupChatId) // entry 为 group_chat_tools/chain_group_chat_toolss时才有值
  store.commit('wwContactUserId', userId) // 企微外部联系人用户id， entry 为 single_chat_tools、contact_profile、chain_single_chat_tools时才有值
  store.commit('wwContactCorpId', corpId) // 企微外部联系人所在企业id，entry 为 chain_single_chat_tools、chain_group_chat_tools时才有值
}

async function bindContactToCpp_Del (externalUserId) {
  try {
    console.log('开始绑定外部联系人与Cpp联系人: ' + externalUserId)
    if (!externalUserId) {
      const resp = await ww.getCurExternalContact()
      if (resp.errCode === 0) {
        externalUserId = resp.userId
      }
    }

    if (!externalUserId) {
      console.error('外部联系人userId为空')
      return
    }
    // 获取外部联系人详细信息
    const data = await getExternalContact(externalUserId)
    const extContact = data.external_contact
    getCppContact(extContact.external_userid).then((data) => {
      if (data && data.contacts) {
        if (data.contacts.length === 1) {
          // 绑定外部联系人与Cpp联系人
          console.log('匹配到一个联系人，自动绑定: ', data.contacts[0])
          bindCppContact(extContact, data.contacts[0]).then((res) => {
            console.log('自动绑定结果: ', res)
            // 注意：数组有 bing_log_id 但无 contact_id 只是预绑定，还需要人工审核或进一步确定哪个系统联系人绑定
            this.$vue.$emit('bindCppContact', {
              extContact,
              cppContact: data.contacts[0],
              isAuto: true
            })
          })
        } else {
          // TODO: 显示选择Cpp联系人的对话框,由用户确定
          $vue.$toast('匹配到多个业务系统的联系人，需要手动选择绑定')
        }
      } else {
        // 显示得到的联系人列表，可以提示用户手动绑定
        console.error('未匹配到业务系统联系人: ', data)
      }
    }).catch(err => {
      console.error('查找系统联系人失败，需要手动绑定: ', err)
      $vue.$toast('查找系统联系人失败，需要手动绑定')
    })
  } catch (err) {
    console.error('绑定外部联系人失败: ', err)
  }
}

// 根据微信外部联系人id 获取详细信息
// 服务端 API 文档参考 https://developer.work.weixin.qq.com/document/path/92265
async function getExternalContact(externalUserId) {
  return new Promise((resolve, reject) => {
    $fetch.wwGetExternalContact({
      corpid: user.ww_corpid, // 授权方企业CorpID
      userid: externalUserId // 外部联系人的userid
    }).then((resp) => {
      console.log('获取外部联系人详细信息成功: ', resp)
      resolve(resp.data)
    }).catch((err) => {
      console.log('获取外部联系人信息失败: ', err)
      reject(err)
    })
  })
}

async function getCppContact (externalUserId) {
  return $fetch.wwGetCppContact({
    userid: externalUserId
  })
}
async function bindCppContact (extContact, erpContact) {
  return this.$vue.$fetch.wwkBindCppContact({
    userid: extContact.external_userid,
    name: extContact.name, // 外部联系人的名称, 如果是微信用户(type=1)则返回其微信昵称。如果是企业微信联系人(type=2)则返回其设置对外展示的别名或实名
    type: extContact.type, // 外部联系人的类型，1表示该外部联系人是微信用户，2表示该外部联系人是企业微信用
    avatar: extContact.avatar, // 外部联系人头像，第三方不可获取, 代开发自建应用需要管理员授权才可以获取
    corp_name: extContact.corp_name, // 仅当联系人类型是企业微信用户时有此字段
    corp_full_name: extContact.corp_full_name, // 仅当联系人类型是企业微信用户时有此字段
    unionid: extContact.unionid, // 第三方应用和代开发应用均不可获取
    contact_id: erpContact.contact_id,
    contact_name: erpContact.contact_name,
    cus_id: erpContact.cus_id,
    cus_name: erpContact.cus_name
  })
}

export default {
  // $vue: $vue,
  // $fetch: fetch,
  // wxworkJsApies,
  initWecomSdk,
  handleAppEntry,
  getContext,
  bindContactToCpp_Del,
  getExternalContact,
  getCppContact,
  bindCppContact,
  getCurExternalContact
}



// WEBPACK FOOTER //
// ./src/plugins/wxworkJsapi.js